export default {
  cards: {
    chart: {
      sumberKurikulum: {
        queryName: "sumber_kurikulum",
        content: {
          title: "Sumber Kurikulum",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik sumber kurikulum",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 450,
          },
          chartOption: {
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Sumber Kurikulum",
              dataIndex: "sumber_kurikulum",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      komposisiKurikulum: {
        queryName: "komposisi_kurikulum",
        content: {
          title: "Komposisi Kurikulum",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik komposisi kurikulum",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: "100%",
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                formatter: (value) => {
                  return value.split(" ").join("\n");
                },
              },
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Komposisi Kurikulum",
              dataIndex: "kurikulum_komposisi",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      evaluasiAkademik: {
        queryName: "evaluasi_akademik",
        content: {
          title: "Frekuensi Evaluasi Akademik",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik frekuensi evaluasi akademik",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            backgroundColor: "#389BF6",
            titleColor: "white",
          },
          chartOption: {
            textStyle: {
              color: "white",
            },
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "white",
                },
              },
            ],
          },
          columns: [
            {
              title: "Evaluasi Akademik",
              dataIndex: "evaluasi_akademik",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      evalNonAkademik: {
        queryName: "evaluasi_nonakademik",
        content: {
          title: "Komponen Evaluasi Non Akademik",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik komponen evaluasi non akademik",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 450,
          },
          chartOption: {
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Evaluasi Non Akademik",
              dataIndex: "evaluasi_nonakademik",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      mediaPembelajaran: {
        queryName: "evaluasi_media_pembelajaran",
        content: {
          title: "Media Pembelajaran",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik media pembelajaran",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 450,
          },
          chartOption: {
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Media Pembelajaran",
              dataIndex: "evaluasi_mediapembelajaran",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
    },
  },
};
